import _ from 'lodash'
import { deepKeys, setProperty } from 'dot-prop'

export const responsiveBlockStyleLayers = ['base', 'sm', 'md', 'lg']

export type BlockStyle<T extends Record<string, any>> = {
  [Property in keyof T]: T[Property]
}

export type ResponsiveBlockStyle<T extends Record<string, any>> = {
  [Property in keyof T]: {
    [Layer in (typeof responsiveBlockStyleLayers)[number]]: T[Property]
  }
}

export function getScreenStyle<T extends Record<string, any>>(
  responsive: ResponsiveBlockStyle<T>,
  screen: 'lg' | 'md' | 'sm' | 'xl' | '2xl',
) {
  const style: Partial<BlockStyle<T>> = {}
  const keys = deepKeys(responsive)
  for (const layer of responsiveBlockStyleLayers) {
    const layerKeys = keys.filter((key) => key.endsWith('.' + layer))
    for (const key of layerKeys) {
      setProperty(style, key.replace(/\.[^.]+$/, ''), _.get(responsive, key))
    }
    if (layer === screen) {
      break
    }
  }
  return style
}
